import { render, staticRenderFns } from "./purchaseManage.vue?vue&type=template&id=a56a1faa&scoped=true&"
import script from "./purchaseManage.vue?vue&type=script&lang=js&"
export * from "./purchaseManage.vue?vue&type=script&lang=js&"
import style0 from "./purchaseManage.vue?vue&type=style&index=0&id=a56a1faa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56a1faa",
  null
  
)

component.options.__file = "purchaseManage.vue"
export default component.exports